import Button from '@atlaskit/button/new';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { ViewId } from '@databases/types/database/view';
import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import useView from '../../hooks/useView';
import { messages } from '../../i18n';

const footerContainerStyles = xcss({
  width: '100%',
  bottom: 'space.0',
  backgroundColor: 'elevation.surface',
  zIndex: 'navigation',
  flexWrap: 'wrap',
});

export interface ViewSettingsFooterProps {
  contentId: string;
  handleViewUpdate: () => void;
  handleSaveAsNewView: () => void;
  viewNameIsValid: boolean;
  hasChanges: boolean | undefined;
  canEditViews: boolean;
}

const ViewSettingsFooter: FunctionComponent<ViewSettingsFooterProps> = ({
  handleViewUpdate,
  handleSaveAsNewView,
  viewNameIsValid,
  hasChanges,
  canEditViews,
}) => {
  const { view } = useView();
  const { formatMessage } = useIntl();
  const viewId = view.id;

  const isButtonDisabled = !viewNameIsValid || !hasChanges;
  const showUpdateButton = viewId !== ViewId.UNSAVED;

  return canEditViews ? (
    <Inline
      alignInline="center"
      spread="space-between"
      space="space.100"
      xcss={footerContainerStyles}
    >
      <Box xcss={xcss({ flex: '1' })}>
        <Button
          shouldFitContainer
          onClick={handleSaveAsNewView}
          isDisabled={isButtonDisabled}
        >
          {formatMessage(messages['view-settings-panel.save-as-new-view-label'])}
        </Button>
      </Box>
      {showUpdateButton && (
        <Box xcss={xcss({ flex: '1' })}>
          <Button
            appearance="primary"
            onClick={handleViewUpdate}
            shouldFitContainer
            isDisabled={isButtonDisabled}
          >
            {formatMessage(messages['view-settings-panel.update-view-label'])}
          </Button>
        </Box>
      )}
    </Inline>
  ) : null;
};

export default ViewSettingsFooter;
